<template>
  <div id="app">

    <Head ref="head" v-if="$route.name !== 'yywy' && $route.name !== 'yjey'"></Head>
    <router-view />
    <Footer v-if="$route.name !== 'yywy' && $route.name !== 'yjey'"></Footer>
    <iconComponents :isMobile="_isMobile" v-if="$route.name !=='yywy' && $route.name !== 'yjey'"></iconComponents>
  </div>
</template>

<script>
  import Head from '@/components/Head'
  import Footer from '@/components/Footer'
  import iconComponents from './components/iconComponents.vue'
  export default {
    name: 'App',
    data() {
      return {
        _isMobile: false,
      }
    },
    updated(){
      this.$refs.head.checkNavStyle(this.$router.history.current.path.slice(1))
    },
    created() {
      this._isMobile = this.$util._isMobile()
    },
    components: {
      Head,
      Footer,
      iconComponents
    },
    //配置移动端页面meta
    metaInfo() {
      return {
        meta: [{
          name: 'viewport',
          content: 'width=device-width, user-scalabled=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0'
        }]
      }
    }
  }
</script>

<style lang="less">
.swiper-pagination-bullet{
  width: 8px!important;
  height:8px!important;
}
</style>
<style lang="less">
  body {
    padding: 0;
    margin: 0;
  }

  .container {
    width: 1200px;
    margin: 0 auto;
  }

html,body{
	width: 100%;
	height: 100%

}
*{
	margin: 0;
	padding:0;
}
iframe{
	width: 99%;
	height: 99%;
	overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue